import request from "../request";
import { auditLogAction } from "./auditLog";

export const validateBulkEmailChanges = async (props) => {
	const { email_data, company_id, env } = props;

	const req = await request({
		url: `${env}/bulkEmailChanges/${company_id}`,
		method: "POST",
		data: {
			email_data,
			env,
			company_id,
		},
	});

	return req;
};

export const updateBulkEmailChanges = async (props) => {
	const { email_data, company_id, env, selected_user } = props;
	const req = await request({
		url: `${env}/updateBulkEmailChanges/${company_id}`,
		method: "POST",
		data: {
			email_data,
			env,
			company_id,
			selected_user,
		},
	});
	const isSuccess = req?.data?.success === true;
	const metaData = {
		company_id,
		email_data,
		success: isSuccess,
	};

	if (isSuccess) {
		await auditLogAction(env, "BULK_CHANGE_EMAIL", metaData);
	} else {
		await auditLogAction(env, "BULK_CHANGE_EMAIL", {
			...metaData,
			error: "UPDATE FAILED - No emails were updated",
		});
	}
	return { data: req, isSuccess };
};

export const getCurrentUserEmails = async (props) => {
	const { companyID, env } = props;

	const req = await request({
		url: `${env}/bulkEmailChanges/${companyID}`,
		method: "GET",
	});

	const currentUsers = req?.data?.currentUsers;
	const error = req?.data?.error;

	return { currentUsers, error };
};

export const getCurrentCompanyAdmins = async (props) => {
	const { companyID, env } = props;

	const req = await request({
		url: `${env}/bulkEmailChanges/${companyID}/companyAdmins`,
		method: "GET",
	});

	const companyAdmins = req?.data?.companyAdmins;
	const error = req?.data?.error;

	return { companyAdmins, error };
};
